import { useTagStore } from '~/stores/tag'

import { AvailableInfluencerBadges as availableTags } from '~/enums/AvailableInfluencerBadges'

type BadgeName = (typeof availableTags)[number]

export function useGetCuratorBadgeName() {
  const { $pinia } = useNuxtApp()
  const { GET_TAG_FROM_ID } = useTagStore($pinia)

  return (tagId: number) => {
    const badgeName = GET_TAG_FROM_ID(tagId)?.name as BadgeName | undefined

    if (!badgeName || !availableTags.includes(badgeName)) return ''

    return badgeName
  }
}
